import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home.vue'

Vue.use(VueRouter)

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/research',
      name: 'research',
      component: () => import('./views/Research.vue')
    },
      {
          path: '/events',
          name: 'events',
          component: () => import('./views/Events.vue')
      },
      {
          path: '/editions',
          name: 'editions',
          component: () => import('./views/Editions.vue')
      },
      {
          path: '/database',
          name: 'database',
          component: () => import('./views/Database.vue')
      },
      {
          path: '/stories/laodice',
          name: 'laodice',
          component: () => import('./views/stories/laodice.vue')
      },
      {
          path: '/stories/gismondi',
          name: 'gismondi',
          component: () => import('./views/stories/gismondi.vue')
      },
      {
          path: '/stories/bernasconi',
          name: 'bernasconi',
          component: () => import('./views/stories/bernasconi.vue')
      },
      {
          path: '/stories/adaptation',
          name: 'adaptation',
          component: () => import('./views/stories/adaptation.vue')
      },
      {
          path: '/stories/vincislao',
          name: 'vincislao',
          component: () => import('./views/stories/vincislao.vue')
      },
      {
        path: '/stories/bruscolini',
        name: 'bruscolini',
        component: () => import('./views/stories/bruscolini.vue')
      },
      {
        path: '/stories/imeneo',
        name: 'imeneo',
        component: () => import('./views/stories/imeneo.vue')
      },
      {
          path: '/stories',
          name: 'stories',
          component: () => import('./views/Stories.vue')
      },
      {
          path: '/database/places',
          name: 'places',
          component: () => import('./views/Places.vue')
      },
      {
        path: '/database/person/:id',
        name: 'person',
        component: () => import('./views/Person.vue')
      },
      {
          path: '/database/work/:id',
          name: 'work',
          component: () => import('./views/Work.vue')
      },
      {
          path: '/database/expression/:workId/:exprId',
          name: 'Expression',
          component: () => import('./views/Expression.vue')
      },
      {
          path: '/database/source/:workId/:sourceId',
          name: 'Source',
          component: () => import('./views/Source.vue')
      },
      {
        path: '/database/org/:id',
        name: 'org',
        component: () => import('./views/Org.vue')
      },
      {
        path: '/database/place/:id',
        name: 'place',
        component: () => import('./views/Place.vue')
      },
      {
          path: '/links',
          name: 'links',
          component: () => import('./views/Links.vue')
      },
      {
          path: '/contact',
          name: 'contact',
          component: () => import('./views/Contact.vue')
      },
      {
          path: '/imprint',
          name: 'imprint',
          component: () => import('./views/Imprint.vue')
      },
      {
          path: '/checkFontAwesome',
          name: 'fontAwesome',
          component: () => import('./views/checkFontAwesome.vue')
      }
  ]
})
